/*
 * Copyright (c) 2024-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export enum PermissionResource {
  // All Admin - AccelByte User
  ALL = 'ADMIN:*',

  // IC service.
  INVITE = 'ADMIN:INVITE',
  USERS = 'ADMIN:USER',
  CLIENTS = 'ADMIN:CLIENT',
  CLIENT = 'ADMIN:CLIENT:{clientId}',
  ROLES = 'ADMIN:ROLE',
  ROLE = 'ADMIN:ROLE:{roleId}',

  ORGANIZATION_INVITE = 'ADMIN:ORG:{organizationId}:INVITE',
  ORGANIZATION_USERS = 'ADMIN:ORG:{organizationId}:USER',
  ORGANIZATION_USER = 'ADMIN:ORG:{organizationId}:USER:{userId}',

  // Customer database.
  ORGANIZATIONS = 'ADMIN:ORG',
  PROJECTS = 'ADMIN:PROJ',

  ORGANIZATION = 'ADMIN:ORG:{organizationId}',
  ORGANIZATION_PROJECTS = 'ADMIN:ORG:{organizationId}:PROJ',
  ORGANIZATION_PROJECT = 'ADMIN:ORG:{organizationId}:PROJ:{projectId}',

  // Environment
  ENVIRONMENT = 'ADMIN:ENVIRONMENT',

  // Contact Tags
  CONTACT_TAG = 'ADMIN:CONTACTTAG',

  // Others
  FEATURE_FLAGS = 'ADMIN:FEATURE_FLAGS',

  // Notification templates.
  CUSTOMER_NOTIFICATIONS = 'ADMIN:NOTIFICATION:TEMPLATERESOLVER',

  // Release management.
  RELEASE_MGMT = 'ADMIN:RELEASE_MGMT',

  // Admin Portal What's New posts.
  WHATS_NEW = 'ADMIN:WHATSNEW'
}

export enum PermissionAction {
  CREATE = 1,
  READ = 2,
  UPDATE = 4,
  DELETE = 8
}

export enum PermissionName {
  CREATE = 'Create',
  READ = 'Read',
  UPDATE = 'Update',
  DELETE = 'Delete'
}
